import { Box, Typography } from '@mui/material'
import Link from 'next/link'
import { useRouter } from 'next/router'

import Anchor from '@ecm/ui/element/Anchor'
import Button from '@ecm/ui/element/Button'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'
import useSmallScreen from '@ecm/ui/hook/UseSmallScreen'

import carbonFootprintIcon from '/public/images/icon/carbon_footprint.svg'
import junkMailIcon from '/public/images/icon/junk_mail.svg'
import paperlessCompanyIcon from '/public/images/icon/paperless_company.svg'
import paperlessIcon from '/public/images/icon/paperless.svg'

const articles = [
  {
    icon: paperlessIcon,
    label: (
      <>
        Go <b>paperless</b>
      </>
    ),
    slug: 'more-ways-to-go-paperless-you-havent-thought-of',
  },
  {
    icon: paperlessCompanyIcon,
    label: (
      <>
        Become a{' '}
        <b>
          paperless
          <br />
          company
        </b>
      </>
    ),
    slug: '5-simple-steps-to-help-achieve-a-paperless-company',
  },
  {
    icon: carbonFootprintIcon,
    label: (
      <>
        Reduce your
        <br />
        <b>carbon footprint</b>
      </>
    ),
    slug: 'ways-to-reduce-your-carbon-footprint ',
  },
  {
    icon: junkMailIcon,
    label: (
      <>
        Get rid of
        <br />
        <b>junk mail</b>
      </>
    ),
    slug: 'get-rid-of-junk-mail-while-helping-the-environment',
  },
]

const Articles = () => {
  const router = useRouter()
  const isSmallScreen = useSmallScreen()

  return (
    <Box bgcolor={Color.smoke.lightest}>
      <MainContainer
        sx={{
          py: '2em',
        }}
      >
        <Box
          display="grid"
          gap={{ lg: '3em', md: undefined }}
          gridTemplateColumns={{ lg: 'repeat(2, 1fr)', md: '1fr' }}
          alignItems="center"
        >
          <Typography variant="h3" component="h2" maxWidth="470px">
            How you can help the environment
          </Typography>
          <Typography variant="p2" color={Color.saint.normal}>
            Earth Class Mail provides the tools to enable environmentally-friendly companies.{' '}
            <b>We’re fully committed to protecting our planet with you. Ready to get involved?</b>
          </Typography>
        </Box>
        <Box
          display="grid"
          gap="2em"
          gridTemplateColumns={{ lg: 'repeat(4, 1fr)', sm: 'repeat(2, 1fr)', xs: '1fr' }}
          py={{ md: '4em', sm: '3em', xs: '2em' }}
        >
          {articles.map((item, index) => (
            <Box
              key={index}
              bgcolor={Color.white.normal}
              borderRadius="16px"
              p="3.5em 1.5em 1.5em"
              textAlign="center"
              onClick={() => router.push(`/blog/${item.slug}`)}
              sx={{
                ':hover': {
                  boxShadow: '0px 10px 20px rgba(23, 41, 115, 0.06)',
                },
                cursor: 'pointer',
                transition: 'box-shadow 0.15s ease-in-out',
              }}
            >
              <CloudflareImage src={item.icon} height={96} />
              <Anchor href={`/blog/${item.slug}`} variant="p2" fontWeight="400" display="block">
                {item.label}
              </Anchor>
              <Anchor href={`/blog/${item.slug}`} margin="1em 0 0" caret>
                Learn more
              </Anchor>
            </Box>
          ))}
        </Box>
        <Box textAlign="center" pb="3em">
          <Link href="/blog/category/green">
            <Button primary width="auto">
              {isSmallScreen ? 'Learn more' : 'Learn more about making your mail green'}
            </Button>
          </Link>
        </Box>
      </MainContainer>
    </Box>
  )
}

export default Articles
